(function($, undefined) {
	'use strict';
	let desktopSlides;

	var init = function() {
		setupCarousels();

		$('.save-com-blogs-category-btn').on('click', onSaveComBlogsFilterSettings);
		$('.com-blogs-admin-checkbox').on('change', onAdminCheckboxChange);
		$('.stool-shared-tab-ctn[data-tab=com-blogs-blogs]').on('click', '.com-blogs-admin__delete-custom-btn', deleteCustomBlogItem);
	};

	function setupCarousels() {
		const carousels = $('.com-blogs__carousel');

		carousels.each((_, carousel) => {
			const context = $(carousel).closest('.com-blogs');
			const prevArrow = $('.com-blogs__nav-arrow_prev', context);
			const nextArrow = $('.com-blogs__nav-arrow_next', context);
			var isInFolder = context.closest('.folder-section').length > 0;
			desktopSlides = isInFolder ? 2 : 3;
			$(carousel).slick({
				infinite: false,
				slidesToShow: desktopSlides,
				slidesToScroll: 1,
				dots: false,
				prevArrow,
				nextArrow,
				accessibility: true,
				variableWidth: false,
				responsive: [
					{
						breakpoint: 1440,
						settings: {
							slidesToShow: isInFolder ? desktopSlides + .2 : desktopSlides + .2
						}
					},
					{
						breakpoint: 1100,
						settings: {
							slidesToShow: isInFolder ? desktopSlides - 1 + .2 : desktopSlides + .2
                        }
                    },
                    {
						breakpoint: 1023,
						settings: {
							slidesToShow: isInFolder ? desktopSlides - 1 + .2 : 2.2,
						}
					},
					{
						breakpoint: 599,
						settings: {
							slidesToShow: 1.1,
						}
					},
					{
						breakpoint: 399,
						settings: {
							slidesToShow: 1,
						}
					}
				]
			});
		});
	}

	function onSaveComBlogsFilterSettings() {
		var btn = $(this);
		var ctn = btn.closest('.stool-shared-popup-content-ctn-inner');
		var filterLabel = btn.attr("data-filter-label");
		var typeOfSave = $('.com-blogs-admin-checkbox:checked', ctn).val();
		var settingString = "";

		if (typeOfSave == "category") {
			var categoryId = $('[name=categoryId]', ctn).val();
			if (categoryId) {
				settingString = "c:" + categoryId;
			}
		} 
		else {
			var itemsWithBlogIds = $('.com-blogs-admin__delete-custom-btn', ctn);
			if (itemsWithBlogIds.length > 0){
                settingString = "b:";
				settingString += $.map(itemsWithBlogIds, (el) => {
					return el.dataset.id;
				}).join(',');
			}
		}

		var count = $('[name=blogs-count]', ctn).val();

		updateLabel(filterLabel, settingString, $("html").attr("lang"), () => {
			updateLabel(filterLabel + ".count", count, $("html").attr("lang"), () => {
				$('.form-message_success', ctn).slideDown(300);

				setTimeout(() => {
					$('.form-message_success', ctn).slideUp(300);
				}, 3000);
			}, true);
		}, true);
	}

	function onAdminCheckboxChange() {
		var cb = $(this);
		var id = cb.attr("id");
		var ctn = cb.closest('.stool-shared-tab-ctn');

		$('.com-blogs-admin__choice-type:not([data-id=' + id + '])', ctn).slideUp();
		$('.com-blogs-admin__choice-type[data-id=' + id + ']', ctn).slideDown();
	}

	function deleteCustomBlogItem({currentTarget}) {
		let ctn = currentTarget.parentNode;
		ctn.parentNode.removeChild(ctn);
	}

	$(window).ready(function() {
		init();
	});
})(jQuery);
